import { BaseDataService } from './BaseDataService';
import { ScoreCardGroupCharacteristic } from '../../models';
import { NotificationService } from '../../services';

export class ScoreCardGroupCharacteristicDataService extends BaseDataService<ScoreCardGroupCharacteristic> {
    constructor(notificationService: NotificationService) {
        super('Score Card Group Characteristic', 'Score Card Group Characteristics', notificationService);
    }

    public getAllByGroup(id: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/byGroup/${id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving characterisics.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/ScoreCardGroupCharacteristicDataService.tsx